var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content layout",class:_vm.isAsideColor ? 'elAsideWhite' : ''},[_c('el-container',{staticClass:"content"},[_c('el-container',[_c('el-aside',{style:({
          width: _vm.isCollapse ? _vm.closeWidth : _vm.openWidth,
        })},[_c('Sliber')],1),_c('el-main',[_c('div',{staticClass:"headerBox"},[_c('el-header',[_c('Header')],1),_c('BreadCrumb')],1),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }